import { initSentry } from './sentry';
initSentry();

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.scss';
import App from './App/App.tsx';
import Error from './pages/Error/Error.tsx';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<Error fullscreen />} showDialog={false}>
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>,
);
